import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardFilterType } from '../../../types/dashboard-filter.type';
import { getDefaultDashboardFilter } from '../../../../menupoints/boards/create/consts/dashboard-filter-default';
import { VehiclesService } from '../vehicles/vehicles.service';
import { BoardService } from '../board/board.service';

@Injectable({
	providedIn: 'root',
})
export class DashboardFilterService {
	private vehiclesService = inject(VehiclesService);
	private boardService = inject(BoardService);

	getDefaultFilter(): Observable<DashboardFilterType> {
		const existingVehicles = this.getVehiclesFromLastDashboard();

		if (existingVehicles?.length) {
			return of({
				...getDefaultDashboardFilter(),
				vehicles: existingVehicles,
			});
		}

		return this.vehiclesService.loadDefaultVehicle().pipe(
			map((res) => {
				const vehicles = res ? [res] : [];
				return {
					...getDefaultDashboardFilter(),
					vehicles: vehicles,
				};
			}),
			catchError(() => {
				return of(getDefaultDashboardFilter());
			})
		);
	}

	private getVehiclesFromLastDashboard() {
		const boards = this.boardService.boards();

		for (let i = boards.length - 1; i >= 0; i--) {
			const vehicles = boards[i].dashboardFilter?.vehicles;
			if (vehicles?.length) {
				return vehicles;
			}
		}

		return undefined;
	}
}
